<template>
  <router-view></router-view>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

// import axios from 'axios';
// import config from './const'

export default {
  name: 'App',
  async created() {
    // 移設
  },
  async mounted() {
    console.log('vue app mounted', this.$store.state.auth)
    await this.setApp()
  },
  components: {
    // HelloWorld
  },
  methods: {
    async setApp() {
      if (
        this.$store.state.auth.token == null ||
        this.$store.state.auth.token == 'null' ||
        this.$store.state.auth.token == undefined ||
        this.$store.state.auth.token == 'undefined' ||
        this.$store.state.auth.token == ''
      ) {
        const ls_token = localStorage.getItem('token')
        if (typeof ls_token === 'string' && ls_token.length > 0) {
          console.log('App ls_token login', ls_token)
          await this.loadAccount(ls_token)
        } else {
          console.log('App ls_token login?', this.$store.state.auth.token)
          // this.$router.push({ path: logoutPath });
        }
      } else if (
        (this.$store.state.auth.userId == null ||
          this.$store.state.auth.userId == 'null' ||
          this.$store.state.auth.userId == false ||
          this.$store.state.auth.userId == 'false' ||
          this.$store.state.auth.userId == undefined ||
          this.$store.state.auth.userId == 'undefined') &&
        this.$store.state.auth.token != null &&
        this.$store.state.auth.token != 'null' &&
        this.$store.state.auth.token != undefined &&
        this.$store.state.auth.token != 'undefined' &&
        this.$store.state.auth.token != ''
      ) {
        console.log('app created login tokenだけ', this.$store.state.auth.token)
        await this.loadAccount(this.$store.state.auth.token)
      } else if (
        !this.$store.state.auth.limit_timestamp ||
        this.$store.state.auth.limit_timestamp == null ||
        this.$store.state.auth.limit_timestamp == 'null' ||
        this.$store.state.auth.limit_timestamp == undefined ||
        this.$store.state.auth.limit_timestamp == 'undefined' ||
        this.$store.state.auth.limit_timestamp == '' ||
        parseInt(this.$store.state.auth.limit_timestamp) <
          parseInt(Math.floor(Date.now() / 1000))
      ) {
        console.log(
          'timestamp check',
          this.$store.state.auth.limit_timestamp,
          Math.floor(Date.now() / 1000)
        )
        // this.$router.go({ path: '/logout', force: true })
      } else {
        console.log(
          'app check page getMyData!!! loginしてる',
          this.$store.state.auth
        )
      }
      console.log('app check page getMyData!!! logout', this.$store.state.auth)
      document.documentElement.setAttribute('lang', 'ja')
    },
    async loadAccount(tokenval) {
      const loginInfo = {
        token: tokenval
      }
      console.log('handleLogin')
      return this.$store
        .dispatch('tokenLogin', loginInfo)
        .then(response => {
          console.log('login success', loginInfo, response)
          if (!response || !response.token || !response.userId) {
            this.$router.go({ path: '/logout', force: true })
          }
          // this.$router.push({ path: '/' })
        })
        .catch(err => {
          console.log('handleLogin err', err)
          this.$router.go({ path: '/logout', force: true })

          this.throwReject(err)
        })
        .finally(() => {
          console.log('handleLogin finally')
          this.$router.go({ path: '/', force: true })
          // this.$router.push({ path: '/pos/pos' });
        })
    }
  },
  computed: {
    // axiosHeader: function(){
    //   return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
    // },
  }
}
</script>
